import type { SocketFactory } from "./simulator";
import type { WebSocketLike } from "./rpc";

/**
 * Browser WebSocket. Browsers cannot set an Authorization header on a WebSocket, so Basic Auth
 * (security profile 1/2) credentials go in the URL userinfo, which Chromium and Firefox turn into
 * the Authorization header of the upgrade request.
 */
export const browserSocketFactory: SocketFactory = (url, protocols, auth) => {
  let target = url;
  if (auth) {
    const parsed = new URL(url);
    parsed.username = encodeURIComponent(auth.username);
    parsed.password = encodeURIComponent(auth.password);
    target = parsed.toString();
  }
  return new WebSocket(target, protocols) as unknown as WebSocketLike;
};

/** Node >= 22 global WebSocket (undici), which accepts request headers. */
export const nodeSocketFactory: SocketFactory = (url, protocols, auth) => {
  const NodeWebSocket: any = (globalThis as any).WebSocket;
  if (!NodeWebSocket) throw new Error("This Node.js has no global WebSocket (Node >= 22 required)");
  const headers = auth
    ? { Authorization: `Basic ${(globalThis as any).Buffer.from(`${auth.username}:${auth.password}`).toString("base64")}` }
    : undefined;
  return new NodeWebSocket(url, headers ? { protocols, headers } : protocols) as WebSocketLike;
};
